import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { api } from "@/lib/api";

export default function PublicLayout() {
  const [site, setSite] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/site-content")
      .then(({ data }) => setSite(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-red-700 border-t-transparent" />
      </div>
    );
  }

  const whatsapp = site?.whatsapp || "923419300560";
  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="public-layout">
      <Header />
      <main className="flex-1">
        <Outlet context={{ site }} />
      </main>
      <Footer site={site} />

      {/* Floating WhatsApp bubble */}
      <a
        href={`https://wa.me/${whatsapp}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp"
        className="fixed bottom-6 left-6 z-40 w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white grid place-items-center shadow-xl shadow-emerald-500/30 transition-transform hover:scale-110"
      >
        <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-60" aria-hidden />
        <MessageCircle className="w-6 h-6 relative" />
      </a>
    </div>
  );
}
